export default __webpack_public_path__ + "static/media/OSMOS_NEBBIA-RIBBED_60X120_02.aa291b06.jpg";